import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-smart-strength',
  templateUrl: './smart-strength.component.html',
  styleUrls: ['./smart-strength.component.css']
})
export class SmartStrengthComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
